export const SET_CREDIT_REQUEST_BY_MY_WORKLIST = 'myWorklist/SET_CREDIT_REQUEST_BY_WORKLIST';
